import { Dispatch } from "redux";
import {
  getTasks,
  createTask,
  updateTask,
  deleteTask,
} from "../../services/TaskService";
import { Task } from "../../types/Task";

// Action Types
export enum TaskActionType {
  FETCH_TASKS = "FETCH_TASKS",
  ADD_TASK = "ADD_TASK",
  EDIT_TASK = "EDIT_TASK",
  DELETE_TASK = "DELETE_TASK",
}

// Action Interfaces
export interface FetchTasksAction {
  type: TaskActionType.FETCH_TASKS;
  data: Task[];
}

export interface AddTaskAction {
  type: TaskActionType.ADD_TASK;
  data: Task;
}

export interface EditTaskAction {
  type: TaskActionType.EDIT_TASK;
  data: Task;
}

export interface DeleteTaskAction {
  type: TaskActionType.DELETE_TASK;
  data: number;
}

export type TaskAction =
  | FetchTasksAction
  | AddTaskAction
  | EditTaskAction
  | DeleteTaskAction;

// Thunks
export const fetchTasks = () => async (dispatch: Dispatch) => {
  const data = await getTasks();
  dispatch<FetchTasksAction>({ type: TaskActionType.FETCH_TASKS, data });
};

export const addTask = (task: Task) => async (dispatch: Dispatch) => {
  const response = await createTask(task);
  dispatch<AddTaskAction>({
    type: TaskActionType.ADD_TASK,
    data: response.data.data,
  });
};

export const editTask =
  (id: number, task: Task) => async (dispatch: Dispatch) => {
    const response = await updateTask(id, task);
    dispatch<EditTaskAction>({
      type: TaskActionType.EDIT_TASK,
      data: response.data.data,
    });
  };

export const deleteTaskById = (id: number) => async (dispatch: Dispatch) => {
  await deleteTask(id);
  dispatch<DeleteTaskAction>({ type: TaskActionType.DELETE_TASK, data: id });
};
